import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-timesheet.png'


const _withScopeId = n => (_pushScopeId("data-v-0645e764"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "OHeader__Logo ml-10",
  src: _imports_0
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Timesheet", -1))
const _hoisted_3 = { class: "OHeader__Link" }
const _hoisted_4 = {
  key: 0,
  class: "OHeader__Item"
}
const _hoisted_5 = ["onClick"]

import Toolbar from "primevue/toolbar"
  import TieredMenu from "primevue/tieredmenu"
  import { ref } from "vue"
  import { AutenticacaoStore } from "@/store/autenticacao/autenticacao.store"
  import { RouteLocationRaw, useRouter } from "vue-router"
  import { MenuItemLabelType } from "primevue/menuitem"
  import { usarPermissionamento } from "@/composable/UsarPermissionamento"
  import SessaoServico from "@/servicos/sessao.service"
  import { useI18n } from "vue-i18n"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OHeader',
  setup(__props) {

  const { t } = useI18n()

  const { deslogar } = AutenticacaoStore()
  const permissionadorProfissionais = usarPermissionamento("Profissionais")
  const permissionadorUsuarios = usarPermissionamento("Usuarios")
  const permissionadorProjetos = usarPermissionamento("Projetos")
  const permissionadorImportadores = usarPermissionamento("Importacoes")
  const permissionadorTravamento = usarPermissionamento("Travamento")
  const permissionadorTiposDeAtividade = usarPermissionamento("TiposDeAtividade")


  const itensDoMenuFlutuante = [
    {
      label: t("timesheet"),
      icon: "pi pi-fw pi-timesheet",
      to: "/",
      visible: true,
    },
    {
      separator: true,
      visible: permissionadorUsuarios.verificarPermissao("visualizar"),
    },
    {
      label: t("usuarios"),
      to: "/usuarios",
      visible: permissionadorUsuarios.verificarPermissao("visualizar"),
    },
    {
      label: t("gestaoDeTravamentos"),
      to: "gestao-travamentos",
      visible:
        permissionadorTravamento.verificarPermissao("visualizar")
    },
    {
      label: t("importacoes"),
      to: "/importacoes",
      visible: permissionadorImportadores.verificarPermissao("visualizar"),
    },
    {
      separator: true,
    },
    {
      label: t("sair"),
      icon: "pi pi-logout",
      to: "/",
      visible: true,
    },
    {
      separator: false,
    },
  ]

  const itensDoMenuNavegacao = [
    {
      label: t("acompanhamento"),
      icon: "pi pi-fw pi-calendar",
      to: "/atividades",
      key: "0",
      visible: true,
    },
    {
      label: t("projetos"),
      icon: "pi pi-fw pi-map",
      to: "/projetos",
      key: "1",
      visible:
        permissionadorProjetos.verificarPermissao("criar") ||
        permissionadorProjetos.verificarPermissao("visualizar"),
    },
    {
      label: t("profissionais"),
      icon: "pi pi-fw pi-users",
      to: "/profissionais",
      key: "3",
      visible:
        permissionadorProfissionais.verificarPermissao("criar") ||
        permissionadorProfissionais.verificarPermissaoPorGrupo(
          "visualizar",
          "outros"
        ),
    },
    {
      label: t("tiposDeAtividade"),
      icon: "pi pi-fw pi-list",
      to: "/tipos-atividade",
      key: "4",
      visible:
        permissionadorTiposDeAtividade.verificarPermissao("visualizar") ||
        permissionadorTiposDeAtividade.verificarPermissao("listar"),
    },
    {
      label: t("estatisticas"),
      icon: "pi pi-fw pi-chart-line",
      to: "/estatisticas",
      key: "5",
      visible: true,
    },
  ]

  const router = useRouter()
  const menu = ref()

  const toggleMenuFlutuante = (event: Event) => {
    menu.value.toggle(event)
  }

  const executar = (path?: RouteLocationRaw, label?: MenuItemLabelType) => {
    if (path && label !== t("sair")) {
      router.push(path)
      return
    }
    deslogar()
  }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TabMenu = _resolveComponent("TabMenu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Toolbar), {
      "aria-controls": "overlay_tmenu",
      "aria-haspopup": "true",
      class: "OHeader",
      "data-testid": "OHeader"
    }, {
      start: _withCtx(() => [
        _createElementVNode("em", {
          onClick: toggleMenuFlutuante,
          class: "OHeader__IconeMenuBento pi pi-bento",
          role: "button"
        }),
        _hoisted_1,
        _hoisted_2
      ]),
      end: _withCtx(() => [
        _createVNode(_component_TabMenu, {
          class: "OHeader__TabMenu",
          "data-testid": "menu",
          model: itensDoMenuNavegacao
        }, {
          item: _withCtx(({ item }) => [
            (item.visible)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "OHeader__ItemMenu",
                  to: (item.to as string)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("em", {
                      class: _normalizeClass(item.icon)
                    }, null, 2),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(TieredMenu), {
      ref_key: "menu",
      ref: menu,
      class: "OHeader__MenuBento",
      model: itensDoMenuFlutuante,
      popup: true
    }, {
      item: _withCtx(({ item }) => [
        (item.to && item.visible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("a", {
                onClick: ($event: any) => (executar(item.to, item.label))
              }, [
                (item.icon)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(item.icon)
                    }, null, 2))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(item.label), 1)
              ], 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})